import React from 'react';
import FullPageMessage from '../../../common/fullPageMessage/FullPageMessage';
import {
	BUTTON_OPEN_HELP,
	ONBOARDING_ERROR_TRUSTED_PARTY_CANNOT_ACTIVATE_TITLE,
	ONBOARDING_ERROR_TRUSTED_PARTY_CANNOT_ACTIVATE_DESCRIPTION,
} from '../../../../constants/Copy';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { openHelp } from '../../../../actions/helpActions';

const DefaultTrustedPartyCannotActivate = () => {
	const { partnerName } = useParams();
	const dispatch = useDispatch();

	return (
		<FullPageMessage
			button={{
				onClick: () => dispatch(openHelp()),
				text: BUTTON_OPEN_HELP,
			}}
			title={ONBOARDING_ERROR_TRUSTED_PARTY_CANNOT_ACTIVATE_TITLE}
			description={ONBOARDING_ERROR_TRUSTED_PARTY_CANNOT_ACTIVATE_DESCRIPTION.replaceAll(
				'{trustedParty}',
				partnerName
			)}
		/>
	);
};

export default DefaultTrustedPartyCannotActivate;
